import toast from 'react-hot-toast';
import api from './api';
import useAppStore from '../store/app.store';

// Coleções dos módulos Financeiro, Contratos, Acompanhamento e Comercial.
// O banco é a fonte da verdade; o store local vira só um espelho.
export const COLECOES = {
  recorrentes: 'Financeiro', dividas: 'Financeiro', transacoes: 'Financeiro',
  contratos: 'Contratos',
  metas: 'Acompanhamento', followups: 'Acompanhamento',
  metas_comerciais: 'Comercial', registros_comerciais: 'Comercial', verbas_trafego: 'Comercial',
};
const NOMES = Object.keys(COLECOES);

const versoes = {};          // coleção → versão no servidor (ausente = ainda não existe lá)
let pendentes = [];          // coleções que só existem neste navegador, aguardando o envio
let aplicandoServidor = false;
let desinscrever = null;
const timers = {};
const ouvintes = new Set();

const avisar = () => ouvintes.forEach((fn) => fn([...pendentes]));
export const ouvirPendentes = (fn) => { ouvintes.add(fn); fn([...pendentes]); return () => ouvintes.delete(fn); };

const aplicar = (parcial) => {
  aplicandoServidor = true;
  useAppStore.setState(parcial);
  aplicandoServidor = false;
};

const salvar = async (colecao) => {
  const dados = useAppStore.getState()[colecao] || [];
  try {
    const { data } = await api.put(`/dados/${colecao}`, { dados, versao_base: versoes[colecao] ?? null });
    versoes[colecao] = data.versao;
  } catch (err) {
    if (err.response?.status === 409 && err.response.data?.atual) {
      const { dados: atuais, versao } = err.response.data.atual;
      versoes[colecao] = versao;
      aplicar({ [colecao]: atuais });
      toast.error('Estes dados foram alterados em outro lugar. Carreguei a versão mais recente: refaça sua última alteração.', { duration: 7000 });
    } else {
      toast.error('Não foi possível salvar no servidor. Verifique a conexão.');
    }
  }
};

const agendar = (colecao) => {
  clearTimeout(timers[colecao]);
  timers[colecao] = setTimeout(() => { delete timers[colecao]; salvar(colecao); }, 700);
};

// Busca tudo do servidor; o que já existe lá substitui a cópia local
export const carregar = async () => {
  const { data } = await api.get('/dados');
  const local = useAppStore.getState();
  const parcial = {};
  pendentes = [];
  NOMES.forEach((c) => {
    if (timers[c]) return; // alteração local ainda não enviada: não sobrescreve
    const remoto = data.colecoes[c];
    if (remoto) {
      versoes[c] = remoto.versao;
      parcial[c] = remoto.dados;
    } else {
      delete versoes[c];
      if ((local[c] || []).length) pendentes.push(c);
    }
  });
  aplicar(parcial);
  avisar();
};

export const iniciar = async () => {
  if (desinscrever) return;
  try { await carregar(); } catch { return; }
  desinscrever = useAppStore.subscribe((estado, anterior) => {
    if (aplicandoServidor) return;
    NOMES.forEach((c) => {
      if (estado[c] !== anterior[c] && !pendentes.includes(c)) agendar(c);
    });
  });
  document.addEventListener('visibilitychange', aoVoltar);
};

// Ao voltar para a aba, pega o que mudou em outro aparelho
const aoVoltar = () => { if (document.visibilityState === 'visible') carregar().catch(() => {}); };

export const parar = () => {
  if (desinscrever) desinscrever();
  desinscrever = null;
  document.removeEventListener('visibilitychange', aoVoltar);
};

// Envia para o servidor os dados que só existiam neste navegador
export const enviarPendentes = async () => {
  for (const c of [...pendentes]) {
    // eslint-disable-next-line no-await-in-loop
    await salvar(c);
  }
  await carregar();
};
